module.exports = __webpack_public_path__ + "static/media/calefont17.93639f15.png";